import React, { useState } from "react";
import GlobeIcon from "../assets/icons/globe.png"; // Adjust if needed
import { handleGetLanguage, handleSetLanguage } from "../utils/languageStorage";

const CustomSelect = () => {
    const [isShown, setIsShown] = useState(false);
    const language = handleGetLanguage();

    const options = [
        { value: "en", label: "EN" },
        { value: "ka", label: "KA" },
    ];

    const handleSelectChange = (value) => {
        handleSetLanguage(value);
        window.location.reload();
    };

    return (
        <div className="relative">
            <button
                onClick={() => setIsShown((prev) => !prev)}
                // className="w-10 h-10 md:w-10 md:h-10 rounded-full flex items-center justify-center bg-white dark:bg-slate-900 border border-black dark:border-white shadow"
                className="dropdown-toggle translate-y-[3px] size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full  text-white hover:bg-orange-400"
          >
                <img
                    src={GlobeIcon}
                    alt="Select Language"
                    className="w-full h-full md:w-full md:h-full object-contain"
                />
            </button>

            {isShown && (
                <div className="absolute mt-2 right-0 z-50 w-24 bg-white border border-gray-300 rounded-md shadow-md dark:text-black">
                    {options.map((option) => (
                        <button
                            key={option.value}
                            onClick={() => {
                                handleSelectChange(option.value);
                                setIsShown(false);
                            }}
                            className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;